/**
 * Import Dependency
 */
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
// import { defineMessages } from 'react-intl'
// import Swiper from 'react-id-swiper'
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
// import Scrollbar from 'smooth-scrollbar-react'
// import { Popover, NavBar, Icon, Flex } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import styles from '../assets/styles/components/About'
import Modal from './Modal'
import cloudinary from 'helpers/cloudinary'
import { IPHONEX_WIDTH } from '../constants/mediaQuery'
import moment from 'moment'
import _ from 'lodash'
/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */

/**
 * Declare Variable
 */

/**
 * Component
 */
class AboutComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isHorizontal: !(window.innerWidth < window.innerHeight),
    }
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resizeDimension)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
  }

  resizeDimension = () => {
    window.innerWidth < window.innerHeight
      ? this.setState({ isHorizontal: false })
      : this.setState({ isHorizontal: true })
  }

  handleBottomActionSheetToggle = () => {
    this.setState({
      isTriggerBottomActionSheet: !this.state.isTriggerBottomActionSheet,
    })
  }

  renderOpenings = (openingsWithSurcharge) => {
    if (!openingsWithSurcharge) return
    const { intl } = this.props
    // Intl
    const _weekdaysText = [
      intl.formatMessage({ id: 'weekdays.sunday' }),
      intl.formatMessage({ id: 'weekdays.monday' }),
      intl.formatMessage({ id: 'weekdays.tuesday' }),
      intl.formatMessage({ id: 'weekdays.wednesday' }),
      intl.formatMessage({ id: 'weekdays.thursday' }),
      intl.formatMessage({ id: 'weekdays.friday' }),
      intl.formatMessage({ id: 'weekdays.saturday' }),
    ]
    // const _minuteText = intl.formatMessage({ id: 'times.minute' })
    const _toText = intl.formatMessage({ id: 'times.to' })
    const _24hr = intl.formatMessage({ id: 'times.24hr' })

    return _.map(openingsWithSurcharge, (openings, index) => {
      if (!openings) return null

      // Map an array of objects.
      // Each object is an opening period. { startAt: Moment, endAt: Moment }.
      const openingMoments = openings.map(opening => {
        const { start, startMin, end, endMin } = opening
        const today = moment().startOf('date')
        const startAt = today.clone().add(start, 'hours').add(startMin, 'minutes')
        const endAt = today.clone().add(end, 'hours').add(endMin, 'minutes')
        return { startAt, endAt }
      })

      // Find overlapping period and save it in results.
      let results = []
      if (openingMoments.length === 1) {
        results = openingMoments
      } else {
        const usedIndexs = []
        openingMoments.forEach((openingA, indexA) => {
          if (usedIndexs.includes(indexA)) return
          usedIndexs.push(indexA)

          const result = openingA
          openingMoments.forEach((openingB, indexB) => {
            if (usedIndexs.includes(indexB)) return

            // Result is wholly overlaped by B.
            const BOverA = moment(result.startAt).isBetween(openingB.startAt, openingB.endAt, undefined, '[]') && moment(result.endAt).isBetween(openingB.startAt, openingB.endAt, undefined, '[]')
            // Result's front is overlaped byB.
            const BOverAFront = moment(openingB.startAt).isSameOrBefore(result.startAt) && moment(openingB.endAt).isBetween(result.startAt, result.endAt, undefined, '[]')
            // Result's end is overlaped by B.
            const BoverAEnd = moment(openingB.startAt).isBetween(result.startAt, result.endAt, undefined, '[]') && moment(openingB.endAt).isSameOrAfter(result.endAt)

            // Whan the result is overlaped by B, change the value of result and store indexB in usedIndex.
            if (BOverA) {
              result.startAt = openingB.startAt
              result.endAt = openingB.endAt
              usedIndexs.push(indexB)
            }

            if (BOverAFront) {
              result.startAt = openingB.startAt
              usedIndexs.push(indexB)
            }

            if (BoverAEnd) {
              result.endAt = openingB.endAt
              usedIndexs.push(indexB)
            }
          })
          results.push(result)
        })
      }

      // Map the result to string.
      const timeStr = results.map(opening => {
        const { startAt, endAt } = opening

        // opening 24 hours
        const opening24hr = startAt.format('HH:mm') === '00:00' && endAt.format('HH:mm') === '00:00'
        if (opening24hr) return _24hr

        const _startAt = opening.startAt.format('HH:mm')
        const _endAt = opening.endAt.format('HH:mm')
        return `${_startAt} ${_toText} ${_endAt}`
      }).join('，')

      if (timeStr) {
        if (timeStr.includes(_24hr)) {
          return (
            <div key={index}>
              {`${_weekdaysText[index]}： ${_24hr}`}
            </div>
          )
        }
        return (
          <div key={index}>
            {`${_weekdaysText[index]}： ${timeStr}`}
          </div>
        )
      }
      return null
    })
  }

  render () {
    const { classes, merchant, intl } = this.props

    // Intl
    const _addressText = intl.formatMessage({ id: 'about.address' })
    const _phoneText = intl.formatMessage({ id: 'about.phone' })
    const _openingText = intl.formatMessage({ id: 'about.opening' })

    const wrapStyle = cx(classes.wrap)
    const aboutWrapStyle = cx(classes['about-wrap'])
    const closeButtonWrapStyle = cx(classes['close-button-wrap'])
    const closeButtonStyle = cx(classes['close-button'])
    const contentWrapStyle = cx(classes['content-wrap'])
    const contentStyle = cx(classes.content)
    const titleDescriptionStyle = cx(classes['title-description'])
    const redLineStyle = cx(classes['red-line'])
    const greenLineStyle = cx(classes['green-line'])
    const titleStyle = cx(classes.title)
    const descriptionStyle = cx(classes.description)

    const otherDescriptionStyle = cx(classes['other-description'])

    const addressStyle = cx(classes.address)
    const addressTitleStyle = cx(classes['address-title'])
    // const addressDescriptionStyle = cx(classes['address-description'])
    const addressZhStyle = cx(classes['address-zh'])
    // const addressEnStyle = cx(classes['address-en'])

    const phoneStyle = cx(classes.phone)
    const phoneTitleStyle = cx(classes['phone-title'])
    const phoneDescriptionStyle = cx(classes['phone-description'])

    const openingStyle = cx(classes.opening)
    const openingTitleStyle = cx(classes['opening-title'])
    const openingDescriptionStyle = cx(classes['opening-description'])

    const aboutIntroStyle = cx(classes['about-intro'])

    const contentPadding = this.state.isHorizontal ? window.innerHeight / 1.5 : window.innerHeight / 5

    return (
      <div className={wrapStyle}>
        <img
          src={cloudinary.transformation(merchant && merchant.images && merchant.images.cover ? merchant.images.cover : '', `w_${IPHONEX_WIDTH}`)}
          width='100%'
          onClick={this.handleBottomActionSheetToggle}
          alt=''
        />

        <Modal>
          <SwipeableBottomSheet
            overflowHeight={0}
            open={this.state.isTriggerBottomActionSheet}
            style={{ zIndex: '99999' }}
            shadowTip={false}
            fullScreen
            swipeableViewsProps={{
              disabled: true,
            }}
          >
            <div
              className={aboutWrapStyle}
              style={{ backgroundImage: cloudinary.transformation(merchant && merchant.images && merchant.images.info ? "url('" + merchant.images.info + "')" : '', `w_${IPHONEX_WIDTH}`) }}
            >
              <div className={closeButtonWrapStyle}>
                <div
                  className={closeButtonStyle}
                  onClick={this.handleBottomActionSheetToggle}
                />
              </div>
              <div className={contentWrapStyle}>
                <div
                  className={contentStyle}
                  style={{ paddingTop: `${contentPadding}px` }}
                >
                  <div className={titleDescriptionStyle}>
                    <div className={redLineStyle} />
                    <div className={titleStyle}>
                      {merchant ? ReactHtmlParser(merchant.name) : ''}
                    </div>
                    <div className={descriptionStyle}>
                      {merchant ? ReactHtmlParser(merchant.desc) : ''}
                    </div>
                    <div className={greenLineStyle} />
                  </div>
                  <div className={otherDescriptionStyle}>
                    <div className={addressStyle}>
                      <div className={addressTitleStyle}>
                        {_addressText}
                      </div>
                      <div className={addressZhStyle}>
                        {merchant ? ReactHtmlParser(merchant.address) : ''}
                      </div>
                    </div>
                    {/* <div className={phoneStyle}>
                      <div className={phoneTitleStyle}>
                        {_phoneText}
                      </div>
                      <div className={phoneDescriptionStyle}>
                        {merchant ? merchant.contact : ''}
                      </div>
                    </div> */}
                    <div className={openingStyle}>
                      <div className={openingTitleStyle}>
                        {_openingText}
                      </div>
                      <div className={openingDescriptionStyle}>
                        {merchant ? this.renderOpenings(merchant.openingsWithSurcharge) : ''}
                      </div>
                    </div>
                    <div className={aboutIntroStyle} />
                  </div>
                </div>
              </div>
            </div>
          </SwipeableBottomSheet>
        </Modal>

      </div>

    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(AboutComponent)



// WEBPACK FOOTER //
// ./src/components/About.js